import UltMeta, { Meta } from "./UltMeta/index";

class VehicleType extends UltMeta {
    SELF_DUMP_TRUCK = new Meta(1, "自卸车");
    FENCE_TRUCK = new Meta(2, "栏板");
    HIGH_SIDED_TRUCK = new Meta(3, "高栏");
    VAN = new Meta(4, "厢式");
    FLATBED_TRUCK = new Meta(5, "平板");
    CONTAINER_TRUCK = new Meta(6, "挂车");
    CONCRETE_MIXER_TRUCK = new Meta(7, "混凝土车");
    TANK_TRUCK = new Meta(8, "罐式车");
    CONTAINER = new Meta(9, "集装箱");
    REFRIGERATED_TRUCK = new Meta(10, "冷藏");
    OTHER = new Meta(11, "其他");
}
export const VEHICLE_TYPE = new VehicleType();

class VehiclePlateColor extends UltMeta {
    BLUE = new Meta(1, "蓝色");
    YELLOW = new Meta(2, "黄色");
    YELLOW_GREEN = new Meta(3, "黄绿色");
}
export const VEHICLE_PLATE_COLOR = new VehiclePlateColor();
